WiseMetering.Views.EditHoliday = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'holiday',
    template: 'templates/holidays/edit',
    title: () => i18next.t('modal.title.holidays.edit')
});
